class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    window.facetsDesktop = false;
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
      window.facetsDesktop = true;
    }
    FacetFiltersForm.setActiveMenuDrawer();
    FacetFiltersForm.initFlavor();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html, event);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html, event);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html, event) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    
    FacetFiltersForm.initFlavor(true, event);
    if (typeof window.collectionSorting === 'function') window.collectionSorting();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    FacetFiltersForm.setActiveMenuDrawer();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  static setActiveMenuDrawer() {
    const wrapper = document.querySelector('.mobile-facets__wrapper');
    const count = Number(document.querySelector('[data-active-filter-count]').dataset.activeFilterCount)

    count > 0 ? wrapper.classList.add('active') : wrapper.classList.remove('active');
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const url = new URL(window.location.href);
    const tagSearchParams = url.searchParams.getAll('filter.p.tag');

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      if (tagSearchParams.length > 0) tagSearchParams.forEach(tag => {forms.push(`filter.p.tag=${tag}`)});
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }

  static initFlavor(render = false, event) {
    if (!window.facetsDesktop && !render) return;
    this.facetFlavor = document.querySelectorAll('#FacetsWrapperDesktop .range-facet--flavor');
    FacetFiltersForm.renderFacetFlavor(render, event);
    setTimeout(() => {FacetFiltersForm.renderFacetFlavorRemove()}, 2);
  }

  static renderFacetFlavor(render, event) {
    let dataList = [];
    let setFlavor = false;
    const filterFlavor = JSON.parse(localStorage.getItem('__filter_flavor'));
    const search = window.location.search;
    const facetRemove = document.querySelectorAll('.active-facets__list .facet-remove');
    const url = new URLSearchParams(window.location.search);

    if ((!search.includes('filter.p.m.custom.flavor_') && !search.includes('filter.p.m.custom.level_')) || facetRemove.length === 0) {
      localStorage.removeItem('__filter_flavor');
      return;
    }
    
    if (event && event.target.classList.contains('range-facet__slider') && event.target.name !== 'filter.v.price.gte_slider' && event.target.name !== 'filter.v.price.lte_slider') setFlavor = true;

    this.facetFlavor.forEach((item, i) => {
      const wrap = item.closest('.facets-wrap');
      const key = wrap.querySelector('legend').dataset.key;
      const itemMin = item.querySelector('.range-facet__slider--min');
      const itemMax = item.querySelector('.range-facet__slider--max');
      const min = Number(itemMin.value);
      const max = Number(itemMax.value);

      if (!url.has(key)) return;
      
      if (render && setFlavor) {
        dataList.push({title: key, min: min, max: max});
      }
      else if (filterFlavor) {
        const thisItem = filterFlavor.find(flavor => flavor.title === key);
        
        if (thisItem.min === min && thisItem.max === max) return;
        itemMin.value = thisItem.min;
        itemMax.value = thisItem.max;
        setTimeout(() => {itemMax.dispatchEvent(new Event("input"))}, 1);
      }
    });
    
    render && setFlavor && localStorage.setItem('__filter_flavor', JSON.stringify(dataList));
  }

  static renderFacetFlavorRemove() {
    this.facetsRemoveAll = document.querySelector('.facet-remove-all');

    this.facetFlavor.forEach(item => {
      const wrap = item.closest('.facets-wrap');
      const title = wrap.querySelector('legend').innerText;
      const key = wrap.querySelector('legend').dataset.key;
      const range = wrap.querySelector('.facets-flavor__display').innerText;
      const min = Number(item.querySelector('.range-facet__slider--min').value);
      const max = Number(item.querySelector('.range-facet__slider--max').value);

      if (min === 0 && max === 10) return;
      const url = new URLSearchParams(window.location.search);
      url.delete(key);
      const href = `${window.location.pathname}?${url.toString()}`;

      this.facetsRemoveAll.insertAdjacentHTML('beforebegin', `
        <facet-remove class="facet-remove">
          <a href="${href}" class="it-button active-facets__button" role="button">
            ${title}: ${range}
            <span class="svg-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path>
              </svg>
            </span>
            <span class="visually-hidden">Xóa bộ lọc</span>
          </a>
        </facet-remove>
      `)
    })
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
      element.addEventListener('input', this.onChangeValue.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  onChangeValue(event) {
    const target = event.target;
    const val = Number(target.value);
    const max = Number(target.max);
    if (!Number.isNaN(val) && val > max) target.value = max;
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class CollectionTags extends HTMLElement {
  constructor() {
    super();
    this.search = this.dataset.page == 'search' ? true : false;
    this.url = this.search ? window.location.href : window.location.pathname;
    this.collectionUrl = this.dataset.collectionUrl;
    this.items = this.querySelectorAll('.relative-tags__item');
    this.links = this.querySelectorAll('.relative-tags__item a');

    this.check();
    this.links.forEach(link => {
      link.addEventListener('click', this.onChange.bind(this));
    });
  }

  check() {
    if (this.url.includes('-gia')) this.active('-gia');
    if (this.url.includes('trung-thu')) this.active('trung-thu');
    if (this.url.includes('yeu-thich')) this.active('yeu-thich');
    if (this.url.includes('mai')) this.active('mai');
    if (this.url.includes('m%E1%BB%9Bi-nh%E1%BA%A5t')) this.active('mới-nhất');
    if (this.url.includes('sức-khoẻ')) this.active('sức-khoẻ');
    if (this.url.includes('vị-giac')) this.active('vị-giac');
  }

  active(val) {
    this.items.forEach(item => {
      item.dataset.tag.includes(val) && item.classList.add('active');
    });
  }

  onChange(event) {
    event.preventDefault();
    const target = event.target;
    this.search ? this.searchPage(target) : this.collectionPage(target);
  }
  
  collectionPage(target) {
    const checkActive = target.parentElement.classList.contains('active') ? true : false;
    const url = new URL(window.location.href);
    let newPathName = '';

    if(!checkActive) newPathName += `/${target.parentElement.dataset.tag}`;

    this.items.forEach(item => {
      if (item.classList.contains('active') && item != target.parentElement) {
        newPathName === '' ? newPathName += `/${item.dataset.tag}` : newPathName += `+${item.dataset.tag}`;
      }
    });

    url.pathname = this.collectionUrl + newPathName;
    window.location.href = url.toString();
  }

  searchPage(target) {
    const checkActive = target.parentElement.classList.contains('active') ? true : false;
    const url = new URLSearchParams(window.location.search);

    url.delete('filter.p.tag');
    if(!checkActive) url.append('filter.p.tag', target.parentElement.dataset.tag);

    this.items.forEach(item => {
      if (item.classList.contains('active') && item != target.parentElement) {
        url.append('filter.p.tag', item.dataset.tag);
      }
    });

    window.location.href = `?${url.toString()}`;
  }
}

customElements.define('collection-tags', CollectionTags);
